// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { Draft } from "immer";

export type xAccountSettingsState = {
    properties: {
        billTrustEmailConfirmations: string;
        billTrustEmailNotify: string;
        billTrustPdfAttachment: string;
    };
};

const initialState: xAccountSettingsState = {
    properties: {
        billTrustEmailConfirmations: "false",
        billTrustEmailNotify: "false",
        billTrustPdfAttachment: "false",
    },
};

const xAccountSettings = createTypedReducerWithImmer(initialState, {
    "Pages/xAccountSettings/UpdateAccountSettings": (
        draft: Draft<xAccountSettingsState>,
        action: {
            properties: {
                billTrustEmailConfirmations: string;
                billTrustEmailNotify: string;
                billTrustPdfAttachment: string;
            };
        },
    ) => {
        if (!draft) {
            throw new Error("There was no properties set and we are trying to update it.");
        }

        if (!action?.properties) {
            return;
        }
        draft.properties.billTrustEmailConfirmations = action?.properties?.billTrustEmailConfirmations?.toString();
        draft.properties.billTrustEmailNotify = action?.properties?.billTrustEmailNotify?.toString();
        draft.properties.billTrustPdfAttachment = action?.properties?.billTrustPdfAttachment?.toString();
    },
    "Pages/xAccountSettings/SetInitialValues": (
        draft: Draft<xAccountSettingsState>,
        action: {
            properties: {
                billTrustEmailConfirmations: string;
                billTrustEmailNotify: string;
                billTrustPdfAttachment: string;
            };
        },
    ) => {
        draft.properties.billTrustEmailConfirmations = action?.properties?.billTrustEmailConfirmations;
        draft.properties.billTrustEmailNotify = action?.properties?.billTrustEmailNotify;
        draft.properties.billTrustPdfAttachment = action?.properties?.billTrustPdfAttachment;
    },
});

(reducers as any).xAccountSettings = xAccountSettings;

type xAccountSettingsRecuder = {
    xAccountSettings: typeof xAccountSettings;
};

export type xAccountSettingsActions = Parameters<xAccountSettingsRecuder[keyof xAccountSettingsRecuder]>[1] | AnyAction;
